import type { HelpFile } from '../../types/help'
import { MyAccessTestIds, MyAccessTabId } from '../../../testids/MyAccessTestIds'

export const myAccessHelp: HelpFile = {
  docPage: '/docs/my-iam/my-access',
  texts: {
    [MyAccessTestIds.myAccessOuterTabs]: null,
    [MyAccessTestIds.tab(MyAccessTabId.AccessProfiles)]:
      'Every active Access Profile grant on this identity — with source rule and expiry date.',
    [MyAccessTestIds.tab(MyAccessTabId.FunctionGroups)]:
      'Function-group assignments — bundles of related Access Profiles assigned as a single unit.',
    [MyAccessTestIds.tab(MyAccessTabId.EffectiveAccess)]:
      'Resolved permissions actually held, across all grant sources.',
    [MyAccessTestIds.tab(MyAccessTabId.Assignments)]:
      'One row per active Access Profile grant on this identity.',
    [MyAccessTestIds.tab(MyAccessTabId.Timeline)]:
      'Chronological record of every access change on this identity.',
    [MyAccessTestIds.tab(MyAccessTabId.FunctionGroupAssignments)]:
      'One row per function-group assignment on this identity.',
    [MyAccessTestIds.tab(MyAccessTabId.FunctionGroupTimeline)]:
      'Chronological record of every function-group assignment change on this identity.',
    [MyAccessTestIds.myAccessRow]:
      'One Access Profile assignment — status, contributing sources, and expiry.',
    [MyAccessTestIds.myEffectiveAccessRow]:
      'One effective access grant — resource, permitted operation, and contributing assignments.',
    [MyAccessTestIds.myEffectiveAccessScopeHint]:
      'Scope of the effective access list, including any active filters.',
    [MyAccessTestIds.myFgAssignmentRow]:
      'One function-group assignment — group name, status, and contributing sources.',
    [MyAccessTestIds.myFgEmpty]:
      'No function-group assignments on this identity.',
    [MyAccessTestIds.colAccessProfiles]:
      'Access Profiles included in this assignment.',
    [MyAccessTestIds.colSources]:
      'Grant sources — direct, role, Auto-Assign Rule, or function group.',
    [MyAccessTestIds.colStatus]: null,
    [MyAccessTestIds.colExpiresAt]: null,
    [MyAccessTestIds.colExpand]: null,
    [MyAccessTestIds.colEaEnforcementObject]:
      'Enforcement Object granted by this effective access entry.',
    [MyAccessTestIds.colEaOperation]:
      'Operation permitted on the resource (read, write, execute, etc.).',
    [MyAccessTestIds.colEaResource]:
      'Resource this effective access applies to.',
    [MyAccessTestIds.colEaSourcesCount]:
      'Number of grant sources contributing to this effective access entry.',
    [MyAccessTestIds.colEaSystem]:
      'Target system this effective access applies to.',
    [MyAccessTestIds.colEaValidFrom]:
      'Date from which this effective access is valid.',
    [MyAccessTestIds.colEaValidTo]:
      'Date until which this effective access is valid.',
    [MyAccessTestIds.colFgName]: null,
    [MyAccessTestIds.colFgStatus]: null,
    [MyAccessTestIds.colFgSources]:
      'Grant sources contributing to this function-group assignment.',
    [MyAccessTestIds.colFgExpiresAt]: null,
  },
}
